import useDesignTokens from '@assetron/web-common/themes/useDesignTokens';
import { useTheme } from '@mui/material';
import { useMemo } from 'react';

const useResetPasswordSuccessContent = () => {
  const theme = useTheme();
  const tokens = useDesignTokens();

  const styles = useMemo(
    () => ({
      root: {
        width: '360px',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: theme.sizeGuide['4xl'],
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
      title: {
        width: '100%',
        display: 'flex',
        textAlign: 'center',
        flexDirection: 'column',
        justifyContent: 'start',
        flex: 1,
      },
      textContainer: {
        marginBottom: theme.sizeGuide['4xl'],
      },
      resetTitle: {
        display: 'block',
      },
      resetDescription: {
        marginTop: theme.sizeGuide.lg,
        color: tokens.colors.text.secondary,
        [theme.breakpoints.down('sm')]: {
          marginTop: theme.sizeGuide.sm,
        },
      },
      buttonContainer: {
        width: '100%',
        paddingBottom: theme.sizeGuide['4xl'],
        [theme.breakpoints.down('sm')]: {
          paddingBottom: theme.sizeGuide.none,
        },
      },
    }),
    [theme, tokens],
  );

  return styles;
};
export default useResetPasswordSuccessContent;
